import { ComponentProps } from "./index"
import { useMouseGesture } from "Hooks/basic"
import { useContext } from "react"
import { PresetContext } from "Components/Preset/context"
import { useDeleteCallback } from "Components/Preset/Modal/hook"

export function useContentItem(props: ComponentProps) {
    const { content, weekDay, place } = props
    const { deletePreset, setPresetModal } = useContext(PresetContext)
    const { creator_info, article_type, description, author, id } = content
    const { department: creatorDepartment } = creator_info || {}
    const { color_code } = article_type || {}
    const { name: authorName = "", user_public: { nickname, department } } = author || {}
    const { color } = creatorDepartment || {}
    const { name: departmentName } = department || {}

    // 预约的背景色
    const backgroundColor = color_code || color
    // 预约的文案
    const text = `[${authorName}] ${description}`
    // tooltip文案
    const tooltip = `${departmentName} ${nickname}预约`
    // 预约删除按钮
    const { show: showDeleteIcon , handleMouseEnter, handleMouseLeave } = useMouseGesture()
    // 删除母版
    const del = async () => {
        await deletePreset({
            variables: { id },
        })
    }
    // 编辑母版
    const handleEditPreset = () => {
        setPresetModal({
            show: true,
            text: "编辑母版",
            type: "update",
            data: {
                weekDay,
                place,
                preset: content,
            },
        })
    }
    const { onDelete } = useDeleteCallback({ confirm: del, cancel: () => {}, text: description })
    return {
        backgroundColor,
        text, tooltip,
        showDeleteIcon, handleMouseEnter, handleMouseLeave,
        onDelete, handleEditPreset,
    }
}
